import { useNavigate, useParams } from 'react-router';
import { useIntl } from 'react-intl';
import routes from '@commons/routes';
import { FilterForm } from './FilterForm';
import { useAppDispatch } from '@store';
import { addFilterWithNotification } from '@store/slices/filtersSlice';

export const CreateFilter = () => {
  const navigate = useNavigate();
  const { username } = useParams();
  const intl = useIntl();
  const dispatch = useAppDispatch();

  const handleSubmit = async (data: any) => {
    const submitData = {
      ...data,
    };

    await dispatch(
      addFilterWithNotification(username as string, submitData, () => {
        navigate(routes.routes.filters.list(username as string));
      })
    );
  };

  return (
    <FilterForm
      title={intl.formatMessage({ id: 'addFilter' })}
      submitButtonText={intl.formatMessage({ id: 'create' })}
      onSubmit={handleSubmit}
    />
  );
};
